import React, { Component } from "react";
import "./ModalController.css";

class Modal extends Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.close = this.close.bind(this);

    this.state = {
      visible: true,
    };
  }

  componentDidMount() {
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    document.addEventListener("click", this.handleClick, false);
    window.addEventListener("scroll", this.handleScroll, false);
    window.addEventListener("keyup", this.handleKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
    window.removeEventListener("scroll", this.handleScroll, false);
    window.removeEventListener("keyup", this.handleKeyUp, false);
  }

  close() {
    this.setState({
      visible: false,
    });

    this.props.onClose();
  }

  handleClick(e) {
    if (this.props.closeOnInsideClick || (this.node && !this.node.contains(e.target))) this.close();
  }

  handleScroll(e) {
    if (this.state.visible) window.scrollTo(0, this.scrollTop);
  }

  handleKeyUp(e) {
    if (e.keyCode === 27) this.close();
  }

  render() {
    if (!this.state.visible) return null;

    return (
      <div className="ModalDiv" onClick={this.handleClick}>
        <span className="ModalClose">
          CLOSE <i className="fas fa-times-circle"></i>
        </span>
        <div
          className="ModalContentDiv"
          ref={(node) => {
            this.node = node;
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

class ModalController extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.renderModal = this.renderModal.bind(this);

    this.state = {
      modalVisible: false,
    };
  }

  handleModalClose() {
    this.setState({
      modalVisible: false,
    });
  }

  handleClick(e) {
    e.stopPropagation();

    if (!this.state.modalVisible)
      this.setState({
        modalVisible: true,
      });
  }

  renderModal() {
    if (!this.state.modalVisible) return null;

    return (
      <Modal onClose={this.handleModalClose} closeOnInsideClick={this.props.closeOnInsideClick}>
        {this.props.modalContent}
      </Modal>
    );
  }

  render() {
    return (
      <div className="ModalControllerDiv" onClick={this.handleClick}>
        {this.props.children}
        {this.renderModal()}
      </div>
    );
  }
}

export default ModalController;
